// Direktiva na renderovanie tabule zapasov - starsia verzia bez viacerych stlpcekov
directives.eventsDirective.events = function() {
    var marked, regionName = leagueCupName = "", directive = {
        "li": {
            // Generuje jedntolive eventy
            "Event<-EventChanceTypes": {
                ".@id": function (a) {
                    // Vylistuje v Odds kurzy pre danu eventChanceType (event)
                    var odd, eventIdentificator;
                    if (offer.page !== "results") {
                        eventIdentificator = this.EventChanceTypeID;
                    } else {
                        eventIdentificator = this.EventID;
                    }
                    if (odd = a.context.Odds[eventIdentificator + "_1"]) this.Odd1 = odd;
                    if (odd = a.context.Odds[eventIdentificator + "_X"]) this.OddX = odd;
                    if (odd = a.context.Odds[eventIdentificator + "_2"]) this.Odd2 = odd;

                    // Parsovanie event detailu (LIVE / next LIVE / Prematch)
                    this.Event = $.extend(this.Event, eventDetail.parseEvent(this.LiveFeedReference, this.LiveBetting, this.SportID, this.ActualGamePartID, this.ActualGamePartTime, this.EventDate, this.EventID));
                    if (!this.Event.Date) this.Event.Date = "&nbsp;";
                    if (!(this.Event.Time += this.Event.Label)) this.Event.Time = "&nbsp;";

                    // Nastavi ID zapasu - s priznakom "M"
                    return ("M" + this.EventID);
                },
                ".@class+": function () {
                    var eventClass = "";
                    if (this.SportID == offer.vgID) {
                        eventClass = " virtual-event";
                    } else if (this.LiveBetting == "Y" || offer.page === "results") {
                        eventClass = " live-event";
                    } else if (this.Event.NextLive) {
                        eventClass = " next-live-event";
                    } else {
                        eventClass = " prematch-event";
                    }
                    return eventClass;
                },
                ".@liveFeed-reference": function () {
                    if (this.LiveFeedReference > 0) return this.LiveFeedReference;
                },
                ".@event-date": function () {
                    if (this.Event.EventDate) return this.Event.EventDate;
                },
                ".@event-parent": function () {
                    return this.EventID;
                },
                ".@betType": "Event.BetType",
                ".@event-chanceType-ID": "Event.EventChanceTypeID",
                ".@chanceType-ID": "Event.ChanceTypeID",
                ".@chanceType-name": "Event.ChanceTypeName",
                ".league-title@sport-id": function (a) {
                    if (this.SportID != -1) {
                        this.SportName = a.context.Labels["SP_" + this.SportID].Name;
                        return 'SP' + this.SportID;
                    } else {
                        this.SportName = a.context.Labels["SE_" + this.SportEventID].Name;
                        return 'SE' + this.SportEventID;
                    }
                },
                ".league-title@region-id": "RE#{Event.RegionID}",
                ".league-title@id": "LC#{Event.LeagueCupID}",
                ".league-title": function (a) {
                    if (a.leagueCupID != this.LeagueCupID) {
                        a.leagueCupID = this.LeagueCupID;
                        if (regionName = a.context.Labels["RE_" + this.RegionID].Name) {
                            if (leagueCupName = a.context.Labels["LC_" + this.LeagueCupID].Name) {
                                if (profile.FlatCSS) {
                                    // Prida triedu flag_CountryId (vlajku v offer table), ak nieje CountryId prida triedu flag_0 (bez vlajky)
                                    var countryID = "0";
                                    if (this.CountryID) countryID = this.CountryID;
                                    if (profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.Widgets?.includes("statistics") && this.BetradarSportID && this.SeasonID) {
                                        return '<div class="ui-block-a label-main sport-bgColor-' + this.SportID + '" sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">'
                                        + '<span class="size22 flag_' + countryID + '"></span>' + regionName + ' - <span>' + leagueCupName + '</span></div>'
                                        + '<div class="ui-block-b label-stats sport-border-color-' + this.SportID + '" onclick="eventDetail.eventDetailStats(' + this.BetradarSportID + ', \'leagueFromOffer\', ' + this.SeasonID + ')">'
                                        + '<span class="stats-table-ico"></span><span class="table-label">' + texts.OfferTableLabel + '</span></div> ';
                                    } else {
                                        return '<div class="label-main sport-bgColor-' + this.SportID + '" sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">'
                                        + '<span class="size22 flag_' + countryID + '"></span>' + regionName + ' - <span>' + leagueCupName + '</span></div>';
                                    }
                                } else {
                                    return '<div class="label-main sport-bgColor-' + this.SportID + '" sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">'
                                        + regionName + ' - <span>' + leagueCupName + '</span></div>';
                                }
                            } else {
                                return '<div sport-name="' + this.SportName + '" region-name="' + regionName + '">' + regionName + '</div>';
                            }
                        }
                    } else {
                        return '<span sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '"></span>';
                    }
                },
                ".league-title@class+": function (a) {
                    if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.SeasonID) {
                        return " ui-grid-a";
                    } else {
                        return " ui-grid-solo";
                    }
                },
                "fieldset@class": function () {
                    var chanceType = "";
                    if (this.EventChanceTypeStatus) chanceType = "chanceType-" + this.EventChanceTypeStatus;
                    if (this.LiveBettingView == -1 || (this.SportID == offer.vgID && !["notstarted", "nonstarted"].includes(this.ActualGamePartID))) chanceType += " event-suspended";
                    if (chanceType) return chanceType;
                },
                // Button 1
                ".ui-block-1 .ui-icon-sports@class+": " sport-#{Event.SportID} region-#{Event.RegionID}",
                ".ui-block-1 a+": function () {
                    if (profile.ShowStatistics) {
                        if (profile.StatisticsParameter === "hasStatistics") {
                            // Statistiky na zobrazenie na vrchnej sb obrazovke (povodne)
                            if (this.EventAnalyseID && this.HasStatistics) return '<span class="ui-icon-main analysis-h2h-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                            else if (this.EventAnalyseID) return '<span class="ui-icon-main analysis-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                            else if (this.HasStatistics) return '<span class="ui-icon-main h2h-ico"></span>';
                        } else if (profile.StatisticsParameter === "hasBetradarHostedStatistics") {
                            // Statistiky na zobrazenie na spodnej sb obrazovke
                            if (this.EventAnalyseID && (this.Widgets?.includes("statistics") && this.SeasonID)) return '<span class="ui-icon-main analysis-h2h-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                            else if (this.EventAnalyseID) return '<span class="ui-icon-main analysis-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                            else if (this.Widgets?.includes("statistics") && this.SeasonID) return '<span class="ui-icon-main h2h-ico"></span>';
                        }
                    }
                },
                ".ui-block-1 a@class+": function () {
                    if (this.LiveBetting == "Y") {
                        // Zobrazi LIVE a podla gamePartID nastavi farbu
                        return ' is-live game-' + this.ActualGamePartID;
                    } else if (this.Event.NextLive) {
                        // Zobrazuje ako nextLive len udalosti, ktore budu v LIVE v ramci akutalnej hodiny
                        return ' next-live';
                    }
                },
                ".ui-block-1 a@onclick": function () {
                    if (!offer.goldenLeague) return 'eventDetail.showEventDetail(' + this.EventID + ')';
                },
                ".ui-block-1 a .ui-btn-text": function () {
                    return '<span>' + this.Event.Date + '</span><p class="ui-li-desc">' + this.Event.Time + '</p>';
                },

                // Button 2
                ".ui-block-2 a@id": function () {
                    if (this.Odd1) return this.Odd1.OddsID;
                },
                ".ui-block-2 a@class+": function () {
                    if (offer.page === "results" || stored.redirectTo === "results") {
                        if (this.Odd1 && this.Odd1.OddsWinning == "Y") {
                            return " winning-odd";
                        } else {
                            return " not-winning-odd";
                        }
                    }
                    if (this.Odd1 && ticket.listCheck(this.Odd1.OddsID)) {
                        marked = true;
                        return ' ui-btn-up-e';
                    } else {
                        marked = false;
                    }
                },
                ".ui-block-2 a@onmousedown": function () {
                    if (this.Odd1) {
                        return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd1.OddsID + ')';
                    } else {
                        return 'ticket.ticketOddModule.ctAddOdd()';
                    }
                },
                ".ui-block-2 a .ui-btn-text": function () {
                    var rate = "&nbsp;";
                    if (this.Odd1 && this.Odd1.OddsRate && (rate = this.Odd1.OddsRate.toFixed(2)) > 1) {
                        return '<div id="flg"></div><span id="crs">' + rate + '</span><p class="ui-li-desc">' + this.EventName.split(" vs. ")[0] + '</p>';
                    } else {
                        return '<div id="flg"></div><span id="crs" class="no-crs">' + rate + '</span><p class="ui-li-desc">' + this.EventName.split(" vs. ")[0] + '</p>';
                    }
                },
                ".ui-block-2 a@tip-type": function () {
                    if (this.Odd1) return this.Odd1.TipType;
                },
                ".ui-block-2 a@tip-name": function (a) {
                    if (offer.page !== "results" && this.Odd1) return a.context.Labels["TP_" + this.Odd1.TipID].Name;
                },

                // Button 3
                ".ui-block-3 a@id": function () {
                    if ((this.LiveBetting == "Y" && this.SportID != offer.vgID) || this.BetType == "DUO") {
                    } else if (this.OddX) return this.OddX.OddsID;
                },
                ".ui-block-3 a@class": function () {
                    if (offer.page === "results" || stored.redirectTo === "results") {
                        if (this.OddX && this.OddX.OddsWinning == "Y") {
                            return " winning-odd";
                        } else {
                            return " not-winning-odd";
                        }
                    }
                    if (this.LiveBetting == "Y" && this.SportID != offer.vgID) {
                        return 'ui-link';
                    } else if (this.BetType == "DUO") {
                        return 'ui-link no-link';
                    } else {
                        if (!marked && this.OddX && ticket.listCheck(this.OddX.OddsID)) {
                            marked = true;
                            return 'ui-btn ui-btn-up-c ui-btn-up-e';
                        } else {
                            return 'ui-btn ui-btn-up-c';
                        }
                    }
                },
                ".ui-block-3 a@onmousedown": function () {
                    if (offer.page === "results" || stored.redirectTo === "results") return;
                    if ((this.LiveBetting == "Y" && this.SportID != offer.vgID) || this.BetType == "DUO") {
                    } else if (this.OddX) {
                        return 'ticket.ticketOddModule.ctAddOdd(' + this.OddX.OddsID + ')';
                    } else {
                        return 'ticket.ticketOddModule.ctAddOdd()';
                    }
                },
                ".ui-block-3 a .ui-btn-text": function () {
                    var rate = "&nbsp;";
                    // LIVE udalost - SKORE
                    if ((this.LiveBetting == "Y" && this.SportID != offer.vgID) || (offer.page === "results" || stored.redirectTo === "results")) {
                        if (!this.Score || this.Score == -1) {
                            return '<div class="ui-btn-score">- : -</div>';
                        } else {
                            // Overtime pri celkovom skore
                            return '<div class="ui-btn-score">' + this.Score.toString()
                                .split(" (")[0].split(" [")[0].split("=")[1]
                                .replace(/:/, " : ") + '</div>';
                        }
                    } else if (this.BetType == "DUO") {
                        // PREMATCH udalost - DUO(VS)
                        return '<div class="ui-btn-vs">vs</div>';
                    } else if (this.OddX && this.OddX.OddsRate && (rate = this.OddX.OddsRate.toFixed(2)) > 1) {
                        // PREMATCH udalost - TRIO(X)
                        return '<div id="flg"></div><span id="crs">' + rate + '</span><p class="ui-li-desc">X</p>';
                    } else {
                        // PREMATCH udalost - TRIO(X) bez kurzu
                        return '<div id="flg"></div><span id="crs" class="no-crs">' + rate + '</span><p class="ui-li-desc">X</p>';
                    }
                },
                ".ui-block-3 a@tip-type": function () {
                    if (this.OddX) return this.OddX.TipType;
                },
                ".ui-block-3 a@tip-name": function (a) {
                    if (offer.page !== "results" && this.OddX) return a.context.Labels["TP_" + this.OddX.TipID].Name;
                },

                // Button 4
                ".ui-block-4 a@id": function () {
                    if (this.Odd2) return this.Odd2.OddsID;
                },
                ".ui-block-4 a@class+": function () {
                    if (offer.page === "results" || stored.redirectTo === "results") {
                        if (this.Odd2 && this.Odd2.OddsWinning == "Y") {
                            return " winning-odd";
                        } else {
                            return " not-winning-odd";
                        }
                    }
                    if (!marked && this.Odd2 && ticket.listCheck(this.Odd2.OddsID)) {
                        marked = true;
                        return ' ui-btn-up-e';
                    }
                },

                ".ui-block-4 a@onmousedown": function () {
                    if (offer.page === "results" || stored.redirectTo === "results") return;
                    if (this.Odd2) {
                        return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd2.OddsID + ')';
                    } else {
                        return 'ticket.ticketOddModule.ctAddOdd()';
                    }
                },
                ".ui-block-4 a .ui-btn-text": function () {
                    var rate = "&nbsp;";
                    if (this.Odd2 && this.Odd2.OddsRate && (rate = this.Odd2.OddsRate.toFixed(2)) > 1) {
                        return '<div id="flg"></div><span id="crs">' + rate + '</span><p class="ui-li-desc">' + this.EventName.split(" vs. ")[1] + '</p>';
                    } else {
                        return '<div id="flg"></div><span id="crs" class="no-crs">' + rate + '</span><p class="ui-li-desc">' + this.EventName.split(" vs. ")[1] + '</p>';
                    }
                },
                ".ui-block-4 a@tip-type": function () {
                    if (this.Odd2) return this.Odd2.TipType;
                },
                ".ui-block-4 a@tip-name": function (a) {
                    if (offer.page !== "results" && this.Odd2) return a.context.Labels["TP_" + this.Odd2.TipID].Name;
                },

                // Button 5
                ".ui-block-5 a@ID": "Event.EventID",
                ".ui-block-5 a@channel": "Event.ChannelID",
                ".ui-block-5 a@class+": function () {
                    var button = "";
                    if (offer.goldenLeague) {
                        button += ' ui-disabled';
                    } else if (offer.sportID == offer.vgID) {
                        if (["ended"].includes(this.ActualGamePartID)) button += ' ui-disabled';
                        if (!["ended", "notstarted", "nonstarted"].includes(this.ActualGamePartID)) {
                            button += ' virtual-game-play';
                            if ((!this.ChannelID || this.ChannelID == stored.topScreenVgChannel)
                                && (!stored.topScreenVgVirtualLeague || (stored.topScreenVgVirtualLeague == this.LeagueCupID))) {
                                if (!stored.topScreenVgVirtualLeague) stored.topScreenVgVirtualLeague = this.LeagueCupID;
                                button += ' virtual-game-playing';
                            }
                        } else if (this.SideBet) {
                            button += ' btn-side-bet';
                        }
                    } else if (this.SideBet && !["ended"].includes(this.ActualGamePartID)) {
                        button += ' btn-side-bet';
                    }
                    if (!marked && ticket.listCheck(null, this.EventID)) button += ' ui-btn-up-e';
                    return button;
                },
                ".ui-block-5 a .ui-btn-text": function () {
                    if (!(offer.sportID == offer.vgID && !["notstarted", "nonstarted"].includes(this.ActualGamePartID)) && this.SideBet && !["ended"].includes(this.ActualGamePartID))
                        return '+' + this.SideBet;
                },
                ".ui-block-5 a@onclick": function () {
                    return 'eventDetail.showEventDetail(' + this.EventID + ')';
                },
                ".ui-block-6": "",
                ".ui-block-7": "",
                ".ui-block-8": "",
                ".ui-block-9": "",
                ".ui-block-10": "",
                ".ui-block-11": "",
                ".ui-block-12": ""
            },
            filter: function () {
                // Vynecha masterChanceType typu VICTORIA, pripadne aj LIVE ak je zakazane
                if (this.EventType == "special") {
                    offer.eventsVictoria = true;
                    return false;
                } else if (!offer.live && this.LiveBetting == "Y") {
                    return false;
                }
            }
        },
        ".@class+": function () {
            return 'old-style-offer';
        },
    }
    T.events = $p("#events #section").compile(directive);
};

// Direktiva na renderovanie tabule zapasov - novsia verzia s viacerymi stlpcami
directives.eventsDirective.eventsSexta = function() {
    var marked;
    var regionName = "";
    var leagueCupName = "";
    var sportName = "";
    lastSportID = 0;
        directive = {
            ".events-sport-header": function (a) {
                a.context.RenderedEvents = [];
                // stored.isFavoriteRender && offer.onlyLive !== 1
                if (!stored.isFavoriteRender) {

                    // Vymazanie Oblubenych udalosti pre aktualne zobrazenie plachty
                    stored.playerFavoriteEventData = [];
    
                    // Hlavicka pre zapasy v liste 'live' zapasov
                    if (this.EventChanceTypes && this.Labels && offer.pointer !== "FA0") {
                        // Zobrazenie 1. Hlavicky (header1) vedla nazvu ligy
                        leagueHeader = true;
                        lastSportID = this.EventChanceTypes[0].SportID;
                        sportName =  this.Labels["SP_" + this.EventChanceTypes[0].SportID].Name;
                        return events.sportHeader(lastSportID, sportName, player.playerFavoritesModule.favoriteButtonState(stored.favTypes.sport, lastSportID));
                    } else if (offer.pointer === "FA0") {
                        // Prvotne zobrazenie v oblubenych
                        lastSportID = 0;
                    }
                } else if (profile.Favorite && stored.PlayerID && stored.PlayerID !== profile.ManualVerifiedPlayerID && offer.page === "onlyLive") {
                    this.EventChanceTypes = stored.playerFavoriteEventData;
                    return events.sportHeader(1, texts.FavoritesHeader, false);
                } else {
                    lastSportID = 0;
                    sportName =  "";
                }
            },
            "li": {
                // Generuje jedntolive eventy
                "Event<-EventChanceTypes": {
                    ".@id": function (a) {
                        // Vylistuje v Odds kurzy pre danu eventChanceType (event)
                        var odd, eventIdentificator;
                        if (offer.page !== "results") {
                            eventIdentificator = this.EventChanceTypeID;
                        } else {
                            eventIdentificator = this.EventID;
                        }
                        if (this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (!a.context.Mapped) {
                                // Priradenie ChanceTypes k unikatnym zapasom
                                a.context.MergedChanceTypes = a.context.EventChanceTypes.slice();

                                for (var i = 0; i < a.context.MergedChanceTypes.length; i++) {
    
                                    var chanceType = a.context.MergedChanceTypes[i];
                                    if (i < a.context.MergedChanceTypes.length) nextChanceType = a.context.MergedChanceTypes[i+1];
    
                                    Object.keys(a.context.Odds).forEach(function (key) {
                                        var tipIDObject;
                                        if (chanceType.EventChanceTypeID === a.context.Odds[key].EventChanceTypeID) {
                                            tipIDObject = a.context.Labels["TP_" + a.context.Odds[key].TipID];
    
                                            chanceType[tipIDObject.ID] = a.context.Odds[key];
                                            $.extend(chanceType[tipIDObject.ID], chanceType[tipIDObject.ID], tipIDObject);
                                        }
                                    });
                                }

                                a.context.header1 = header1 = new Object();
                                a.context.mergedEvents = new Object();
                                // Prejde vsetky duplicitne zapasy a spoji ich do jedneho
                                for (var i = 0; i < a.context.MergedChanceTypes.length; i++) {
                                    // Vytvori objekt s id eventu
                                    var chanceType = a.context.MergedChanceTypes[i];
                                    var containing = false;

                                    Object.keys(a.context.mergedEvents).forEach(function(key) {
                                        if (chanceType.EventID == a.context.mergedEvents[key].EventID) {
                                            // Najdeny duplicitny zapas
                                            containing = true;
                                            header1[chanceType.EventID][chanceType.ChanceTypeID] = {
                                                ChanceTypeName: chanceType.ChanceTypeName,
                                                ChanceTypeID: chanceType.ChanceTypeID,
                                                EventChanceTypeID: chanceType.EventChanceTypeID,
                                                BetType: chanceType.BetType
                                            };

                                            a.context.mergedEvents[key] = $.extend({}, a.context.mergedEvents[key], chanceType);
                                        }
                                    });
                                    // Prida novy zapas
                                    if (!containing) {
                                        header1[chanceType.EventID] = new Object();
                                        header1[chanceType.EventID][chanceType.ChanceTypeID] = {
                                            ChanceTypeName: chanceType.ChanceTypeName,
                                            ChanceTypeID: chanceType.ChanceTypeID,
                                            EventChanceTypeID: chanceType.EventChanceTypeID
                                        };

                                        a.context.mergedEvents[chanceType.EventID] = chanceType;
                                    }
                                }
                                // Prebehlo priradenie ChanceTypes k unikatnym zapasom
                                a.context.Mapped = true;
                            }

                            self = this;

                            var mergedEvent = a.context.mergedEvents[self.EventID];
                            Object.keys(mergedEvent).forEach(function(key_odd) {

                                Object.keys(a.context.header1[mergedEvent.EventID]).forEach(function(heading) {
                                    var actualHeader = a.context.header1[mergedEvent.EventID][heading];
                                    if (actualHeader.EventChanceTypeID === mergedEvent[key_odd].EventChanceTypeID) {
                                        switch (actualHeader.ChanceTypeID) {
                                            // Prve TRIO
                                            case "uf:1":
                                            case "vg3way":
                                                    self['Odd' + mergedEvent[key_odd].TipType] = mergedEvent[key_odd];
                                                    self['Odd' + mergedEvent[key_odd].TipType].ChanceTypeName = actualHeader.ChanceTypeName;
                                                break;
                                            // Prve DUO
                                            case "uf:18":
                                            case "vgto_1_5":
                                                    self['Odd_DUO_' + mergedEvent[key_odd].TipType] = mergedEvent[key_odd];
                                                    self['Odd_DUO_' + mergedEvent[key_odd].TipType].ChanceTypeName = actualHeader.ChanceTypeName;
                                                break;
                                            // Druhe TRIO
                                            case "uf:14":
                                            case "vghc_0_1":
                                                    self['Odd_TRIO_' + mergedEvent[key_odd].TipType] = mergedEvent[key_odd];
                                                    self['Odd_TRIO_' + mergedEvent[key_odd].TipType].ChanceTypeName = actualHeader.ChanceTypeName;
                                                break;
                                        }
                                    }
                                });
                            });
                            a.context.RenderedEvents.push(this.EventID);
                        } else if (!stored.isFavoriteRender) {
                            // Eventy pri ktorych sa nezobrazuje v liste ina, nez masterChance-type
                            if (odd = a.context.Odds[eventIdentificator + "_1"]) this.Odd1 = odd;
                            if (odd = a.context.Odds[eventIdentificator + "_X"]) this.OddX = odd;
                            if (odd = a.context.Odds[eventIdentificator + "_2"]) this.Odd2 = odd;

                            if (odd = a.context.Odds[eventIdentificator + "_1X"]) this.Odd1X = odd;
                            if (odd = a.context.Odds[eventIdentificator + "_X2"]) this.OddX2 = odd;
                            if (odd = a.context.Odds[eventIdentificator + "_12"]) this.Odd12 = odd;

                            if (offer.vgL.uofTennis.includes(this.LeagueCupID)) {
                                // Virtualny tenis
                                if (typeof offer.vti === 'undefined') offer.vti = new Object({
                                    actualFeedReference: "",
                                });
                            }
                        }
                        if (!stored.isFavoriteRender) {
                            // Parsovanie event detailu (LIVE / next LIVE / Prematch)
                            this.Event = $.extend(this.Event, eventDetail.parseEvent(this.LiveFeedReference, this.LiveBetting, this.SportID, this.ActualGamePartID, this.ActualGamePartTime, this.EventDate, this.EventID));
                            if (!this.Event.Date) this.Event.Date = "&nbsp;";
                            if (!(this.Event.Time += this.Event.Label)) this.Event.Time = "&nbsp;";
                            // Spravnu strukturu oblubenej udalosti ulozi pre neskorsie pridanie Oblubenych do plachty
                            if (offer.onlyLive === 1 && stored.PlayerFavorite && stored.PlayerFavorite[stored.favTypes.event] && stored.PlayerFavorite[stored.favTypes.event].includes(this.EventID)) {
                                if (!stored.playerFavoriteEventData) {
                                    stored.playerFavoriteEventData = [];
                                }
                                stored.playerFavoriteEventData.push(this);
                            }
                        }

                        // Nastavi ID zapasu - s priznakom "M"
                        return ("M" + this.EventID);
                    },
                    ".@class+": function () {
                        var eventClass = "";
                        if (this.SportID == offer.vgID) {
                            eventClass = " virtual-event";
                            if (offer.vgL.uofTennis.includes(this.LeagueCupID)) {
                                eventClass += " full-score";
                            }
                        } else if (this.LiveBetting == "Y") {
                            eventClass = " live-event";
                            if (offer.parcialScoreSports.includes(this.SportID) && this.ActualGamePartID !== "notstarted") {
                                eventClass += " full-score";
                            }
                        } else if (this.Event.NextLive) {
                            eventClass = " next-live-event";
                        } else {
                            eventClass = " prematch-event";
                        }

                        eventClass += " " + this.BetType;
                        return eventClass;
                    },
                    ".@liveFeed-reference": function () {
                        if (this.LiveFeedReference > 0) return this.LiveFeedReference;
                    },
                    ".@event-date": function () {
                        if (this.Event.EventDate && !stored.isFavoriteRender) return this.Event.EventDate;
                    },
                    ".@event-parent": function () {
                        return this.EventID;
                    },
                    ".@betType": function () {
                        return this.BetType;
                    },
                    ".@event-chanceType-ID": function() {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return this.EventChanceTypeID;
                    },
                    ".@chanceType-ID": function() {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return this.ChanceTypeID;
                    },
                    ".@chanceType-name": function() {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return this.ChanceTypeName;
                    },
                    ".events-n-sport-header": function (a) {
                        if (!stored.isFavoriteRender && lastSportID !== this.SportID) {
                            lastSportID = Number(this.SportID);
                            sportName = a.context.Labels["SP_" + this.SportID].Name;
                            return events.sportHeader(this.SportID, sportName, player.playerFavoritesModule.favoriteButtonState(stored.favTypes.sport, this.SportID));
                        }
                    },
                    ".events-n-sport-header@class+": function () {
                        if (!lastSportID || lastSportID === this.SportID) {
                            return "-disabled";
                        }
                    },
                    ".league-title@sport-id": function (a) {
                        if (this.SportID != -1) {
                            this.SportName = a.context.Labels["SP_" + this.SportID].Name;
                            return 'SP' + this.SportID;
                        } else {
                            this.SportName = a.context.Labels["SE_" + this.SportEventID].Name;
                            return 'SE' + this.SportEventID;
                        }
                    },
                    ".league-title@region-id": "RE#{Event.RegionID}",
                    ".league-title@id": "LC#{Event.LeagueCupID}",
                    ".league-title": function (a) {
                        // Zobrazenie 1. hlavicky ("Vysledok zapasu", ...) vedla nazvu ligy v liste zpasov
                        if (a.leagueCupID != this.LeagueCupID) {
                            a.leagueCupID = this.LeagueCupID;
                            if (regionName = a.context.Labels["RE_" + this.RegionID].Name) {
                                if (leagueCupName = a.context.Labels["LC_" + this.LeagueCupID].Name) {
                                    if (profile.FlatCSS) {
                                        if (offer.page === "virtualGames") {
                                            this.EventDatePerLeague = this.Event.EventDate.split(' ')[0];
                                        } else {
                                            this.EventTimePerLeague = this.Event.EventDate.split(' ')[1];
                                        }
                                        // Prida triedu flag_CountryId (vlajku v offer table), ak nieje CountryId prida triedu flag_0 (bez vlajky)
                                        var countryID = "0";
                                        var header = "";
                                        if (this.CountryID) countryID = this.CountryID;
                                        if (this.leagueHeaderCount.includes('favorite') && (buttonState = player.playerFavoritesModule.favoriteButtonState(stored.favTypes.leagueCup, this.SportID, a.leagueCupID))) {
                                            header += '<div class="favorite-event '
                                            + buttonState + '" onmousedown="player.playerFavoritesModule.editPlayerFavorite('
                                            + this.SportID + ", "
                                            + this.LeagueCupID + ')"><div class="icon-favorite"></div></div>';
                                        } else if (stored.isFavoriteRender && this.leagueHeaderCount.includes('sportIcon')) {
                                            header += '<div class="league-sport-icon"><i class="ui-icon-sports sport-'
                                            + this.SportID + ' sport-color-'
                                            + this.SportID + ' sport-icon-'
                                            + this.SportID + '"></i></div>';
                                        }
                                        var providerName = ' - ';
                                        if (offer.vgID === offer.sportID) {
                                            // V ligovej hlavicke virtualnych hier sa zobrazuje aj nazov providera a ikonka
                                            providerName = ' -<span class="provider-icon flag_' + this.Provider + ' size33"></span>' + texts["ProviderName" + this.Provider] + ' - ';
                                        }
                                        if (profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.BetradarSportID && this.SeasonID) {
                                            header += '<div class="ui-block-a label-main sport-bgColor-' + this.SportID + '" sport-name="' + a.context.Labels['SP_' + this.SportID].Name + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">' +
                                                '<span class="size22 flag_' + countryID + '"></span>' + regionName + providerName + '<span>' + leagueCupName + '</span></div>' +
                                                '<div class="ui-block-b label-stats sport-border-color-' + this.SportID + '" onclick="eventDetail.eventDetailStats(' + this.BetradarSportID + ', \'leagueFromOffer\', ' + this.SeasonID + ')">' +
                                                '<span class="stats-table-ico"></span><span class="table-label">' + texts.OfferTableLabel + '</span>';
                                        } else {
                                            header += '<div class="label-main sport-bgColor-' + this.SportID + '" sport-name="' + a.context.Labels['SP_' + this.SportID].Name + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">' +
                                                '<span class="size22 flag_' + countryID + '"></span>' + regionName + providerName + leagueCupName + '</span>';
                                        }
                                        var betTypes = "";
                                        if  (offer.regionID === 1239 && offer.provider === offer.providerNameUOF && leagueHeader) {
                                            betTypes += '<div class="league-header bet-type-header-1"><div>'+ this.Odd1.ChanceTypeName + '</div>';
                                            if (profile.VirtualsOctava) {
                                                // Pocet golov 1.5, Handicap goly 0:1
                                                if (this.Odd_DUO_1) betTypes += '<div>' + this.Odd_DUO_1.ChanceTypeName + '</div>';
                                                else if (this.Odd1X) betTypes += '<div>' + this.Odd1X.ChanceTypeName + '</div>';
                                                // Neexistuje ChanceType pre dany zapas
                                                else {
                                                    // Ziska id dalsieho zapasu
                                                    var contains = false;
                                                    var n = 1;
                                                    while (!contains) {
                                                         var nextEvent = a.context.EventChanceTypes[a.pos + n];
                                                            if (nextEvent.EventID !== this.EventID) {
                                                                if (nextEvent.ChanceTypeID === "vgto_1_5" || nextEvent.ChanceTypeID === "uf:18") {
                                                                    betTypes += '<div>' + nextEvent.ChanceTypeName + '</div>';
                                                                    contains = true;
                                                                }
                                                            }
                                                            if (n>10) return;
                                                            n++;
                                                    } 
                                                    if (!contains) {
                                                        betTypes += '<div></div>';
                                                    }
                                                }
    
                                                if (this.Odd_TRIO_1) betTypes += '<div>' +  this.Odd_TRIO_1.ChanceTypeName + '</div>';
                                                else betTypes += '<div></div>';
                                            } else {
                                                // Pocet golov 1.5
                                                if (this.Odd_DUO_1 && this.Odd_DUO_1.ChanceTypeName !== a.actualChanceTypeName) {
                                                    a.actualChanceTypeName = this.Odd_DUO_1.ChanceTypeName;
                                                    if (this.Odd_DUO_1) betTypes += '<div>' + this.Odd_DUO_1.ChanceTypeName + '</div>';
                                                    else if (this.Odd1X) betTypes += '<div>' + this.Odd1X.ChanceTypeName + '</div>';
                                                    else betTypes += '<div></div>';
                                                    // Neexistuje ChanceType pre dany zapas
                                                } else {
                                                    // Ziska id dalsieho zapasu
                                                    var contains = false;
                                                    var n = 1;
                                                    while (!contains) {
                                                         var nextEvent = a.context.EventChanceTypes[a.pos + n];
                                                            if (nextEvent.EventID !== this.EventID) {
                                                                if (nextEvent.ChanceTypeID === "uf:18") {
                                                                    betTypes += '<div>' + nextEvent.ChanceTypeName + '</div>';
                                                                    // this.Odd_DUO_1 = {
                                                                    //     actualChanceTypeName: nextEvent.ChanceTypeName
                                                                    // }
                                                                    a.actualChanceTypeName = nextEvent.ChanceTypeName;
                                                                    contains = true;
                                                                }
                                                            }
                                                            if (n>10) return;
                                                            n++;
                                                    } 
                                                    if (!contains) {
                                                        betTypes += '<div></div>';
                                                    }
                                                }
                                            }
                                            betTypes += '</div>';
                                        }
                                        header += (betTypes + '</div>');
                                        return header;
                                    } else {
                                        return '<div class="label-main sport-bgColor-' + this.SportID + '" sport-name="' + a.context.Labels['SP_' + this.SportID].Name + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">' +
                                            regionName + ' - <span>' + leagueCupName + '</span></div>';
                                    }
                                } else {
                                    return '<div sport-name="' + a.context.Labels['SP_' + this.SportID].Name + '" region-name="' + regionName + '">' + regionName + '</div>';
                                }
                            }
                        } else {
                            return '<span sport-name="' + a.context.Labels['SP_' + this.SportID].Name + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '"></span>';
                        }
                    },
                    ".league-title@class+": function () {
                        this.leagueHeaderCount = [];
                        if (profile.FlatCSS && profile.ShowStatistics && (profile.StatisticsParameter === "hasBetradarHostedStatistics") && this.SeasonID) 
                            this.leagueHeaderCount.push("statistics");
                        if (profile.Favorite) {
                            if (stored.isFavoriteRender) {
                                this.leagueHeaderCount.push("sportIcon");
                            } else {
                                this.leagueHeaderCount.push("favorite");
                            }
                        }
                        if (this.leagueHeaderCount.length === 2) {
                            return " ui-grid-b";
                        } else if (this.leagueHeaderCount.length === 1) {
                            return " ui-grid-a";
                        } else {
                            return " ui-grid-solo";
                        }

                    },
                    ".events-header": function (a) {
                        if (profile.FlatCSS && stored.ExtendedActualOffer) {
                            var betTypes = '';
                            // offer.page === "virtualGames" && this.Provider !== "KRN"
                            if (offer.page === "virtualGames") {
                                var actualDate = this.Event.EventDate.split(' ')[1];
                                if ((a.EventDate != actualDate) || (a.actualChanceTypeName && this.Odd_DUO_1 && (this.Odd_DUO_1.ChanceTypeName !== a.actualChanceTypeName))) {
                                    a.EventDate = actualDate;
                                    if ((offer.regionID === 1239 && offer.provider === offer.providerNameUOF && !leagueHeader) || (this.Odd_DUO_1 && offer.regionID === 1239 && offer.provider === offer.providerNameUOF && (a.actualChanceTypeName && this.Odd_DUO_1.ChanceTypeName !== a.actualChanceTypeName))) {
                                        // Virtualky, vrchna hlavicka Vysledok
                                        betTypes = '<div class="bet-type-header-1"><div>'+ this.Odd1.ChanceTypeName + '</div>';
                                        if (profile.VirtualsOctava) {
                                            // Pocet golov 1.5, Handicap goly 0:1
                                            if (this.Odd_DUO_1) betTypes += '<div>' + this.Odd_DUO_1.ChanceTypeName + '</div>';
                                            else if (this.Odd1X) betTypes += '<div>' + this.Odd1X.ChanceTypeName + '</div>';
                                            else betTypes += '<div></div>';

                                            if (this.Odd_TRIO_1) betTypes += '<div>' +  this.Odd_TRIO_1.ChanceTypeName + '</div>';
                                            else betTypes += '<div></div>';
                                        } else {
                                            // Pocet golov 1.5
                                            if (this.Odd_DUO_1) betTypes += '<div>' + this.Odd_DUO_1.ChanceTypeName + '</div>';
                                            else if (this.Odd1X) betTypes += '<div>' + this.Odd1X.ChanceTypeName + '</div>';
                                            else betTypes += '<div></div>';
                                        }
                                        betTypes += '</div>';
                                    }
                                    if (this.Odd_DUO_1 && this.Odd_DUO_1.ChanceTypeName) {
                                        a.actualChanceTypeName = this.Odd_DUO_1.ChanceTypeName;
                                    }
                                    // Priradi cas
                                    betTypes += '<span class="events-time">' + actualDate + '</span>';

                                    // Priradi Tournament Phase
                                    if (this.TournamentPhaseID && a.context.Labels['PH_' + this.TournamentPhaseID]?.Name) {
                                        betTypes += '<span class="tournament-phase">' + a.context.Labels['PH_' + this.TournamentPhaseID].Name + '</span>';
                                    }

                                    if (this.BetType == "DUO" && stored.offerView.includes('duo'))
                                        // Vyber z ponuky obsahuje len zapasy duo
                                        betTypes += '<div class="bet-type-header-2"><div>1</div><div>2</div></div>';
                                    else if (this.BetType == "DUO" || this.BetType == "TRIO") {
                                        // Vyber z ponuky obsahuje zapasy duo alebo sexta
                                        if (stored.offerView.includes('exclude-12') && !profile.VirtualsOctava) {
                                            // Virtualky, spodna hlavicka kvinta
                                            betTypes += '<div class="bet-type-header-2">';
                                            if (this.Odd1 && this.OddX && this.Odd2) {
                                                betTypes += '<div>' + this.Odd1.Name + '</div>'
                                                    + '<div>' + this.OddX.Name + '</div>'
                                                    + '<div>' + this.Odd2.Name + '</div>';
                                            } else {
                                                betTypes += '<div></div><div></div><div></div>';
                                            }
                                            if (this.Odd_DUO_1 && this.Odd_DUO_2) {
                                                betTypes += '<div>' + this.Odd_DUO_1.Name + '</div>'
                                                    + '<div>' + this.Odd_DUO_2.Name + '</div>';
                                            } else {
                                                betTypes += '<div></div><div></div>';
                                            }
                                            betTypes += '</div>';
                                        } else if (this.Provider === offer.providerNameKRN) {
                                            betTypes += events.betTypeHeader(this);
                                        } else {
                                            // Virtualky, spodna hlavicka oktava
                                            betTypes += '<div class="bet-type-header-2">';
                                            if (this.Odd1 && this.OddX && this.Odd2) {
                                                betTypes += '<div>' + this.Odd1.Name + '</div>'
                                                    + '<div>' + this.OddX.Name + '</div>'
                                                    + '<div>' + this.Odd2.Name + '</div>';
                                            } else {
                                                betTypes += '<div></div><div></div><div></div>';
                                            }
                                            if (this.Odd_DUO_1 && this.Odd_DUO_2) {
                                                betTypes += '<div>' + this.Odd_DUO_1.Name + '</div>'
                                                    + '<div>' + this.Odd_DUO_2.Name + '</div>';
                                            } else if (this.Odd1X && this.OddX2) {
                                                betTypes += '<div>' + this.Odd1X.Name + '</div>'
                                                + '<div>' + this.OddX2.Name + '</div>';
                                            } else {
                                                betTypes += '<div></div><div></div>';
                                            }
                                            if (this.Odd_TRIO_1 && this.Odd_TRIO_X && this.Odd_TRIO_2) {
                                                betTypes += '<div></div><div>' + this.Odd_TRIO_1.Name + '</div>'
                                                    + '<div>' + this.Odd_TRIO_X.Name + '</div>'
                                                    + '<div>' + this.Odd_TRIO_2.Name + '</div>';
                                            } else {
                                                betTypes += '<div></div><div></div><div></div><div></div>';
                                            }
                                            betTypes += '</div>';
                                        }
                                    }
                                } else if (this.EventTimePerLeague) {
                                    betTypes = '<span class="events-date">' + this.EventTimePerLeague + '</span>' + events.betTypeHeader(this);
                                }
                            } else {
                                // Nejedna sa o virtualne hry
                                if (a.EventDate != this.Event.EventDate.split(' ')[0] || (this.SportID !== lastSportID)) {
                                    a.EventDate = this.Event.EventDate.split(' ')[0];
                                    betTypes = '<span class="events-date">' + this.Event.EventDate.split(' ')[0] + '</span>' + events.betTypeHeader(this);
                                } else if (this.EventDatePerLeague) {
                                    betTypes = '<span class="events-date">' + this.EventDatePerLeague + '</span>' + events.betTypeHeader(this);
                                }
                            }
                        }
                        return betTypes;
                    },
                    "fieldset@class": function () {
                        var chanceType = "";
                        if (this.EventChanceTypeStatus) chanceType = "chanceType-" + this.EventChanceTypeStatus;
                        //  event-suspended neplati pre virtualny tenis
                        if (this.LiveBettingView == -1 || (!offer.vgL.uofTennis.includes(offer.leagueCupID) && this.SportID == offer.vgID && !["notstarted", "nonstarted"].includes(this.ActualGamePartID))) chanceType += " event-suspended";
                        if (chanceType) return chanceType;
                    },
                    "fieldset@data-track": function () {
                        if (profile.MatchTracker && this.Widgets?.includes("matchtracker")) {
                            return "mt";
                        }
                    },
                    // GA4 - pridavam title pre trackovanie matchtracker
                    "fieldset@data-track-label": function (a) {
                        if (profile.MatchTracker && this.Widgets?.includes("matchtracker")) {
                            return  `${a.context.Labels['SP_' + this.SportID].Name} - ${regionName}`;
                        }
                    },
                    // Button 1
                    ".ui-block-1 .ui-icon-sports@class+": " sport-#{Event.SportID} region-#{Event.RegionID}",
                    ".ui-block-1 a+": function () {
                        if (profile.ShowStatistics) {
                            if (profile.StatisticsParameter === "hasStatistics") {
                                // Statistiky na zobrazenie na vrchnej sb obrazovke (povodne)
                                if (this.EventAnalyseID && this.HasStatistics) return '<span class="ui-icon-main analysis-h2h-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                                else if (this.EventAnalyseID) return '<span class="ui-icon-main analysis-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                                else if (this.HasStatistics) return '<span class="ui-icon-main h2h-ico"></span>';
                            } else if (profile.StatisticsParameter === "hasBetradarHostedStatistics") {
                                // Statistiky na zobrazenie na spodnej sb obrazovke
                                if (this.EventAnalyseID && (this.Widgets?.includes("statistics") && this.SeasonID)) return '<span class="ui-icon-main analysis-h2h-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                                else if (this.EventAnalyseID) return '<span class="ui-icon-main analysis-ico event-analysis-' + this.EventAnalyseID + '"></span>';
                                else if (this.Widgets?.includes("statistics") && this.SeasonID) return '<span class="ui-icon-main h2h-ico"></span>';
                            }
                        }
                    },
                    ".ui-block-1 a@class+": function () {
                        if (this.LiveBetting == "Y") {
                            // Zobrazi LIVE a podla gamePartID nastavi farbu
                            if (this.LiveBettingView == -1) {
                                return ' is-live game-started';
                            }
                            return ' is-live game-' + this.ActualGamePartID;
                        } else if (this.Event.NextLive) {
                            // Zobrazuje ako nextLive len udalosti, ktore budu v LIVE v ramci akutalnej hodiny
                            return ' next-live';
                        }
                    },
                    ".ui-block-1 a@onclick": function () {
                        if (!offer.goldenLeague) return 'eventDetail.showEventDetail(' + this.EventID + ')';
                    },
                    ".ui-block-1 a .ui-btn-text": function () {
                        return '<span>' + this.Event.Date + '</span><p class="ui-li-desc">' + this.Event.Time + '</p>';
                    },

                    // Button 2 - Nazov zapasu
                    ".ui-block-2 a .ui-btn-text": function () {
                        var eventLabel = '<div id="flg"></div>';
                        var favorite = eventTooltip = '';
                        // Oblubene
                        if (buttonState = player.playerFavoritesModule.favoriteButtonState(stored.favTypes.event, this.SportID, this.LeagueCupID, this.EventID)) {
                            // Oblubene udalosti je mozne pridat len v LIVE
                            favorite = '<span class="favorite-event '
                            + buttonState + '" onmousedown="player.playerFavoritesModule.editPlayerFavorite('
                            + this.SportID + ", "
                            + this.LeagueCupID + ", "
                            + this.EventID + ')"><span class="icon-favorite"></span></span>';
                        }
                        // Tooltip
                        if (offer.page === "results" && this.EventResultComment) {
                            eventTooltip = this.EventResultComment
                        } else {
                            if (this.EventComment) eventTooltip += this.EventComment + "<br>";
                            if (this.AggregateScore) eventTooltip += texts.AggregateScoreText + " <b>" + this.AggregateScore + "</b><br>";
                            if (this.SeriesResult) eventTooltip += texts.SeriesResultText + " <b>" + this.SeriesResult + "</b> ";
                        }
                        if (eventTooltip !== "") {
                            eventTooltip = '<span class="icon icon-info-circle" onmousedown="modal.showTooltip(this, false, true, 251, 67);" tooltip-containing-text="'
                            + eventTooltip + '"></span>';
                        }

                        if (this.LiveBetting == "Y" && (this.SportID != offer.vgID || offer.vgL.uofTennis.includes(offer.leagueCupID))) {
                            var parsedScore = shared.parseScore(this.Score, this.SportID);
                            // Live, Virtualny tenis
                            eventLabel += '<p class="ui-li-desc">' + favorite + events.resolveCards(parsedScore, this.SportID, "Home") + '<span class="team-name">' + this.EventName.split(" vs. ")[0] + '</span>' + shared.resolvePowerPlay(parsedScore, this.SportID, "Home", false);
                            if (!this.Score || this.Score == -1) {
                                eventLabel += '<span class="ui-btn-score"><span class="total-result">- : -</span></span>';
                            } else if (offer.parcialScoreSports.includes(this.SportID) || offer.vgL.uofTennis.includes(this.LeagueCupID)) {
                                eventLabel += '<span class="ui-btn-score">' + eventDetail.prepareScoreForRender(parsedScore) + '</span>';
                            } else {
                                // Overtime pri celkovom skore
                                eventLabel += '<span class="ui-btn-score"><span class="total-result">' + this.Score.toString()
                                    .split(" (")[0].split(" [")[0].split("=")[1]
                                    .replace(/:/, " : ") + '</span></span>';
                            }
                            eventLabel += shared.resolvePowerPlay(parsedScore, this.SportID, "Away", false) + '<span class="team-name">' + this.EventName.split(" vs. ")[1] + '</span>' + events.resolveCards(parsedScore, this.SportID, "Away") + '<span class="icons-wrapper">';
                            // Ikony
                            if (stored.AllowStream && this.Widgets?.includes("stream") && this.Stream && !this.Stream.includes(offer.bannedStreamKeywords) && profile.StreamProviders.includes(this.StreamProvider)) {
                                eventLabel += '<span class="icon-tv" stream-id="' + this.Stream  + '" provider="' + this.StreamProvider + '"></span>';
                            } else if (profile.MatchTracker && this.Widgets?.includes("matchtracker")) {
                                eventLabel += '<span class="icon-field"></span>';
                            }
                            // [Betbuilder Aggregator API] Ikona - zobrazuje sa len ak je zapas v LIVE a ma povoleny Betbuilder pre Live
                            if (profile.BetBuilderAgg && this.Widgets?.includes("betbuilder") && profile.BetBuilderAggLive) {
                                eventLabel += '<span class="icon icon-betbuilder--agg"></span>';
                            }
                            if (offer.vgL.oneVideo.includes(offer.leagueCupID) && offer.vti && offer.vti.actualFeedReference) {
                                eventLabel += '<span class="icon-kiron-stream"></span>';
                            }
                            return eventLabel += eventTooltip + '</span></p>';
                        } else if (offer.page === "results" || stored.redirectTo === "results") {
                            // Vysledky
                            if (this.Score) {
                                eventLabel += '<p class="ui-li-desc">'
                                + favorite + '<span class="team-name">'
                                + this.EventName.split(" vs. ")[0] + '</span>'
                                + '<span class="ui-btn-score">'
                                + this.Score.toString().split(" (")[0].split(" [")[0].split("=")[1].replace(/:/, " : ")
                                + '</span><span class="team-name">'
                                + this.EventName.split(" vs. ")[1] + '</span><span class="icons-wrapper">';
                            } else {
                                eventLabel += '<p class="ui-li-desc">'
                                + favorite + '<span class="team-name">'
                                + this.EventName.split(" vs. ")[0] + '</span><span class="vs"> vs. </span><span class="team-name">'
                                + this.EventName.split(" vs. ")[1] + '</span><span class="icons-wrapper">';
                            }
                            return eventLabel += eventTooltip + '</span></p>';

                        } else {
                            // Kurzova ponuka, Zacinajuce zapasy, Dnes, Neskor, Virtualne hry (bez v. tenisu)
                            eventLabel += '<p class="ui-li-desc">'
                            + favorite + '<span class="team-name">'
                            + this.EventName.split(" vs. ")[0]
                            + '</span><span class="vs"> vs. </span><span class="team-name">'
                            + this.EventName.split(" vs. ")[1] + '</span>'
                            + '<span class="icons-wrapper">';
                            // Ikony
                            // [Betbuilder Aggregator API] Ikona
                            if (profile.BetBuilderAgg && this.Widgets?.includes("betbuilder")) {
                                eventLabel += '<span class="icon icon-betbuilder--agg"></span>';
                            }
                            if (offer.vgL.oneVideo.includes(this.LeagueCupID) && this.Stream === "1") {
                                eventLabel += '<span class="icon-kiron-stream"></span>';
                            }
                            return eventLabel += eventTooltip + '</span></p>';
                        }
                    },
                    ".ui-block-2 a@onclick": function (a) {
                        if (offer.goldenLeague) {
                            return 'eventDetail.showEventDetail()';
                        } else {
                            return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                        }
                    },
                    // Button 3 Sexta - 1
                    ".ui-block-3 a@id": function () {
                        if (this.Odd1) return this.Odd1.OddsID;
                    },
                    ".ui-block-3 a@chanceType-name": function () {
                        if (this.Odd1) return this.Odd1.ChanceTypeName;
                    },
                    ".ui-block-3 a@event-chanceType-ID": function () {
                        if (this.Odd1) return this.Odd1.EventChanceTypeID;
                    },
                    ".ui-block-3 a@odd-status": function () {
                        if (this.Odd1 && this.Odd1.Status && this.Odd1.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-3 a@class+": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd1 && this.Odd1.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (this.Odd1 && this.Odd1.OddsID && ticket.listCheck(this.Odd1.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        } else {
                            marked = false;
                        }
                    },
                    ".ui-block-3 a@onmousedown": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.Odd1) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd1.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-3 a .ui-btn-text": function (a) {
                        var rate = "&nbsp;";
                        if (this.Odd1 && (this.Odd1.OddsRate && ((rate = this.Odd1.OddsRate.toFixed(2)) > 1) || !this.Odd1.TipID)) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-3 a@tip-type": function () {
                        if (this.Odd1) return this.Odd1.TipType;
                    },
                    ".ui-block-3 a@tip-name": function (a) {
                        if (offer.page !== "results" && this.Odd1 && this.Odd1.TipID) return a.context.Labels["TP_" + this.Odd1.TipID].Name;
                    },

                    // Button 4 Sexta - X
                    ".ui-block-4 a@id": function () {
                        if (this.OddX) return this.OddX.OddsID;
                    },
                    ".ui-block-4 a@chanceType-name": function () {
                        if (this.OddX) return this.OddX.ChanceTypeName;
                    },
                    ".ui-block-4 a@event-chanceType-ID": function () {
                        if (this.OddX) return this.OddX.EventChanceTypeID;
                    },
                    ".ui-block-4 a@odd-status": function () {
                        if (this.OddX && this.OddX.Status && this.OddX.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-4 a@class+": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.OddX && this.OddX.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.OddX && this.OddX.OddsID && ticket.listCheck(this.OddX.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-4 a@onmousedown": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.OddX) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.OddX.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-4 a .ui-btn-text": function () {
                        var rate = "&nbsp;";
                        if (this.OddX || (!this.OddX && stored.offerView.includes("sexta"))) {
                            if (this.OddX && (this.OddX.OddsRate && ((rate = this.OddX.OddsRate.toFixed(2)) > 1) || !this.OddX.TipID)) {
                                return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                            } else {
                                return '<span id="crs" class="no-crs">' + rate + '</span>';
                            }
                        } else return '';

                    },
                    ".ui-block-4 a@tip-type": function () {
                        if (this.OddX) return this.OddX.TipType;
                    },
                    ".ui-block-4 a@tip-name": function (a) {
                        if (offer.page !== "results" && this.OddX && this.OddX.TipID) return a.context.Labels["TP_" + this.OddX.TipID].Name;
                    },

                    // Button 5 Sexta - 2
                    ".ui-block-5 a@id": function () {
                        if (this.Odd2) return this.Odd2.OddsID;
                    },
                    ".ui-block-5 a@chanceType-name": function () {
                        if (this.Odd2) return this.Odd2.ChanceTypeName;
                    },
                    ".ui-block-5 a@event-chanceType-ID": function () {
                        if (this.Odd2) return this.Odd2.EventChanceTypeID;
                    },
                    ".ui-block-5 a@odd-status": function () {
                        if (this.Odd2 && this.Odd2.Status && this.Odd2.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-5 a@class+": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd2 && this.Odd2.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.Odd2 && this.Odd2.OddsID && ticket.listCheck(this.Odd2.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-5 a@onmousedown": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.Odd2) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd2.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-5 a .ui-btn-text": function () {
                        var rate = "&nbsp;";
                        if (this.Odd2 && (this.Odd2.OddsRate && ((rate = this.Odd2.OddsRate.toFixed(2)) > 1) || !this.Odd2.TipID)) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-5 a@tip-type": function () {
                        if (this.Odd2) return this.Odd2.TipType;
                    },
                    ".ui-block-5 a@tip-name": function (a) {
                        if (offer.page !== "results" && this.Odd2 && this.Odd2.TipID) return a.context.Labels["TP_" + this.Odd2.TipID].Name;
                    },

                    // Button 6 Sexta - 1X
                    ".ui-block-6 a@id": function () {
                        if (this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (this.Odd_DUO_1 && this.Odd_DUO_1.OddsRate) this.Odd1X = this.Odd_DUO_1;
                        }
                        if (this.Odd1X) return this.Odd1X.OddsID;
                    },
                    ".ui-block-6 a@chanceType-name": function () {
                        if (this.Odd1X) return this.Odd1X.ChanceTypeName;
                    },
                    ".ui-block-6 a@event-chanceType-ID": function () {
                        if (this.Odd1X) return this.Odd1X.EventChanceTypeID;
                    },
                    ".ui-block-6 a@odd-status": function () {
                        if (this.Odd1X && this.Odd1X.Status && this.Odd1X.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-6 a@class+": function () {
                        if (offer.goldenLeague) return " lock-btn";
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd1X && this.Odd1X.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.Odd1X && this.Odd1X.OddsID && ticket.listCheck(this.Odd1X.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-6 a@onmousedown": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.Odd1X) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd1X.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-6 a .ui-btn-text": function () {
                        var rate = "&nbsp;";
                        if (this.Odd1X && (this.Odd1X.OddsRate && ((rate = this.Odd1X.OddsRate.toFixed(2)) > 1) || !this.Odd1X.TipID)) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-6 a@tip-type": function () {
                        if (this.Odd1X) return this.Odd1X.TipType;
                    },
                    ".ui-block-6 a@tip-name": function (a) {
                        if (offer.page !== "results" && this.Odd1X && this.Odd1X.TipID) return a.context.Labels["TP_" + this.Odd1X.TipID].Name;
                    },

                    // Button 7 Sexta - X2
                    ".ui-block-7 a@id": function () {
                        if (this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (this.Odd_DUO_2 && this.Odd_DUO_2.OddsRate) this.OddX2 = this.Odd_DUO_2;
                        }
                        if (this.OddX2) return this.OddX2.OddsID;
                    },
                    ".ui-block-7 a@chanceType-name": function () {
                        if (this.OddX2) return this.OddX2.ChanceTypeName;
                    },
                    ".ui-block-7 a@event-chanceType-ID": function () {
                        if (this.OddX2) return this.OddX2.EventChanceTypeID;
                    },
                    ".ui-block-7 a@odd-status": function () {
                        if (this.OddX2 && this.OddX2.Status && this.OddX2.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-7 a@class+": function () {
                        if (offer.goldenLeague) return " lock-btn";
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.OddX2 && this.OddX2.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.OddX2 && this.OddX2.OddsID && ticket.listCheck(this.OddX2.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-7 a@onmousedown": function () {
                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.OddX2) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.OddX2.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-7 a .ui-btn-text": function () {
                        var rate = "&nbsp;";
                        if (this.OddX2 && (this.OddX2.OddsRate && ((rate = this.OddX2.OddsRate.toFixed(2)) > 1) || !this.OddX2.TipID)) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-7 a@tip-type": function () {
                        if (this.OddX2) return this.OddX2.TipType;
                    },
                    ".ui-block-7 a@tip-name": function (a) {
                        if (offer.page !== "results" && this.OddX2 && this.OddX2.TipID) return a.context.Labels["TP_" + this.OddX2.TipID].Name;
                    },

                    // Button 8
                    ".ui-block-8 a@id": function () {
                        if (this.RegionID === 1239 && offer.provider === offer.providerNameUOF) return;

                        if (this.Odd12) return this.Odd12.OddsID;
                    },
                    ".ui-block-8 a@chanceType-name": function () {
                        if (this.Odd12) return this.Odd12.ChanceTypeName;
                    },
                    ".ui-block-8 a@event-chanceType-ID": function () {
                        if (this.Odd12) return this.Odd12.EventChanceTypeID;
                    },
                    ".ui-block-8 a@odd-status": function () {
                        if (this.Odd12 && this.Odd12.Status && this.Odd12.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-8 a@class+": function () {
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) return " ui-disabled";
                        if (offer.goldenLeague) return " lock-btn";
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd12 && this.Odd12.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.Odd12 && this.Odd12.OddsID && ticket.listCheck(this.Odd12.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-8 a@onmousedown": function () {
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) return;

                        if (offer.page === "results" || stored.redirectTo === "results") return;
                        if (this.Odd12) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd12.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-8 a .ui-btn-text": function () {
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) return;

                        var rate = "&nbsp;";
                        if (this.Odd12 && (this.Odd12.OddsRate && ((rate = this.Odd12.OddsRate.toFixed(2)) > 1) || !this.Odd12.TipID)) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-8 a@tip-type": function () {
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) return;

                        if (this.Odd12) return this.Odd12.TipType;
                    },
                    ".ui-block-8 a@tip-name": function (a) {
                        if (offer.kvintaSports.includes(offer.sportID) || (offer.regionID === 1239 && offer.provider === offer.providerNameUOF)) return;

                        if (offer.page !== "results" && this.Odd12 && this.Odd12.TipID) return a.context.Labels["TP_" + this.Odd12.TipID].Name;
                    },

                    // Button 9 - OddH_0_1_1
                    ".ui-block-9 a@ID": function () {
                        if (profile.VirtualsOctava && this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (this.Odd_TRIO_1 && this.Odd_TRIO_1.OddsRate) {
                                return this.Odd_TRIO_1.OddsID;
                            }
                        } else {
                            return this.EventID;
                        }
                    },
                    ".ui-block-9 a@chanceType-name": function () {
                        if (this.Odd_TRIO_1) return this.Odd_TRIO_1.ChanceTypeName;
                    },
                    ".ui-block-9 a@event-chanceType-ID": function () {
                        if (this.Odd_TRIO_1) return this.Odd_TRIO_1.EventChanceTypeID;
                    },
                    ".ui-block-9 a@channel": function () {
                        if (profile.VirtualsOctava && this.RegionID === 1239 && offer.provider === offer.providerNameUOF) return;
                        else return this.ChannelID;
                    },
                    ".ui-block-9 a@odd-status": function () {
                        if (this.Odd_TRIO_1 && this.Odd_TRIO_1.Status && this.Odd_TRIO_1.Status !== "active") {
                            return 'locked';
                        }
                    },
                    // "Event.ChannelID",
                    ".ui-block-9 a@class+": function () {
                        if (profile.VirtualsOctava && this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (offer.page === "results" || stored.redirectTo === "results") {
                                if (this.Odd_TRIO_1 && this.Odd_TRIO_1.OddsWinning == "Y") {
                                    return " winning-odd";
                                } else {
                                    return " not-winning-odd";
                                }
                            }
                            if (!marked && this.Odd_TRIO_1 && this.Odd_TRIO_1.OddsID && ticket.listCheck(this.Odd_TRIO_1.OddsID)) {
                                marked = true;
                                return ' ui-btn-up-e';
                            }
                        } else {
                            var button = "";
                            if (offer.goldenLeague) {
                                button += ' ui-disabled';
                            } else if (offer.sportID == offer.vgID) {
                                button += virtual.virtualButton(this.LeagueCupID, this.ActualGamePartID, this.LiveBettingView, this.SideBet, this.Stream, this.ChannelID, this.Score);
                            } else if (this.SideBet && !["ended"].includes(this.ActualGamePartID) && offer.page !== "onlyLive") {
                                button += ' btn-side-bet';
                            }
                            if (!marked && ticket.listCheck(null, this.EventID)) button += ' ui-btn-up-e';
                            return button;
                        }
                    },
                    ".ui-block-9 a .ui-btn-text": function () {
                        if (profile.VirtualsOctava && this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            var rate = "&nbsp;";
                            if (this.Odd_TRIO_1 && this.Odd_TRIO_1.OddsRate && (rate = this.Odd_TRIO_1.OddsRate.toFixed(2)) > 1) {
                                return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                            } else {
                                return '<span id="crs" class="no-crs">' + rate + '</span>';
                            }
                        } else if (offer.vgL.uofTennis.includes(this.LeagueCupID) && this.SideBet) {
                            return '+' + this.SideBet;
                        } else {
                            if (!(offer.sportID == offer.vgID && (!["notstarted", "nonstarted"].includes(this.ActualGamePartID)) || this.LiveBettingView == -1) && 
                                this.SideBet && !["ended"].includes(this.ActualGamePartID)) {
                                    // TODO: prekontrolovat ci this.LiveBettingView == -1 je spravna podmienka
                                    if (offer.page !== "onlyLive") {
                                        return '+' + this.SideBet;
                                    }
                            }
                        }
                    },
                    ".ui-block-9 a@tip-type": function () {
                        if (this.Odd_TRIO_1) return this.Odd_TRIO_1.TipType;
                    },
                    ".ui-block-9 a@tip-name": function (a) {
                        if (this.Odd_TRIO_1) return a.context.Labels["TP_" + this.Odd_TRIO_1.TipID].Name;
                    },
                    ".ui-block-9 a@onclick": function () {
                        if (profile.VirtualsOctava && this.RegionID === 1239 && offer.provider === offer.providerNameUOF) {
                            if (this.Odd_TRIO_1) {
                                return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd_TRIO_1.OddsID + ')';
                            } else if (offer.vgL.krnHockey.includes(this.LeagueCupID) && this.Widgets?.includes("stream") === "1") {
                                return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                            } else {
                                return 'ticket.ticketOddModule.ctAddOdd()';
                            }
                        } else {
                            return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                        }
                    },

                    // Button 10
                    ".ui-block-10 a@id": function () {
                        if (this.RegionID !== 1239  && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;
                        if (this.Odd_TRIO_X && this.Odd_TRIO_X.OddsRate) {
                            return this.Odd_TRIO_X.OddsID;
                        }
                    },
                    ".ui-block-10 a@chanceType-name": function () {
                        if (this.Odd_TRIO_X) return this.Odd_TRIO_X.ChanceTypeName;
                    },
                    ".ui-block-10 a@event-chanceType-ID": function () {
                        if (this.Odd_TRIO_X) return this.Odd_TRIO_X.EventChanceTypeID;
                    },
                    ".ui-block-10 a@odd-status": function () {
                        if (this.Odd_TRIO_X && this.Odd_TRIO_X.Status && this.Odd_TRIO_X.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-10 a@class+": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        // if (!(profile.VirtualsOctava && this.Odd_TRIO_X)) return " ui-disabled";
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd_TRIO_X && this.Odd_TRIO_X.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.Odd_TRIO_X && this.Odd_TRIO_X.OddsID && ticket.listCheck(this.Odd_TRIO_X.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-10 a@onmousedown": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (offer.page === "results" || stored.redirectTo === "results" || !profile.VirtualsOctava) return;
                        if (this.Odd_TRIO_X) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd_TRIO_X.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-10 a .ui-btn-text": function () {
                        if (this.RegionID !== 1239  && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        var rate = "&nbsp";
                        if (this.Odd_TRIO_X && this.Odd_TRIO_X.OddsRate && (rate = this.Odd_TRIO_X.OddsRate.toFixed(2)) > 1) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-10 a@tip-type": function () {
                        if (this.RegionID !== 1239  && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;
                        if (this.Odd_TRIO_X) return this.Odd_TRIO_X.TipType;
                    },
                    ".ui-block-10 a@tip-name": function (a) {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (offer.page !== "results" && this.Odd_TRIO_X) return a.context.Labels["TP_" + this.Odd_TRIO_X.TipID].Name;
                    },

                    // Button 11
                    ".ui-block-11 a@id": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;
                        if (this.Odd_TRIO_2 && this.Odd_TRIO_2.OddsRate) {
                            return this.Odd_TRIO_2.OddsID;
                        }
                    },
                    ".ui-block-11 a@chanceType-name": function () {
                        if (this.Odd_TRIO_2) return this.Odd_TRIO_2.ChanceTypeName;
                    },
                    ".ui-block-11 a@event-chanceType-ID": function () {
                        if (this.Odd_TRIO_2) return this.Odd_TRIO_2.EventChanceTypeID;
                    },
                    ".ui-block-11 a@odd-status": function () {
                        if (this.Odd_TRIO_2 && this.Odd_TRIO_2.Status && this.Odd_TRIO_2.Status !== "active") {
                            return 'locked';
                        }
                    },
                    ".ui-block-11 a@class+": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        // if (!(profile.VirtualsOctava && this.Odd_TRIO_2)) return " ui-disabled";
                        if (offer.page === "results" || stored.redirectTo === "results") {
                            if (this.Odd_TRIO_2 && this.Odd_TRIO_2.OddsWinning == "Y") {
                                return " winning-odd";
                            } else {
                                return " not-winning-odd";
                            }
                        }
                        if (!marked && this.Odd_TRIO_2 && this.Odd_TRIO_2.OddsID && ticket.listCheck(this.Odd_TRIO_2.OddsID)) {
                            marked = true;
                            return ' ui-btn-up-e';
                        }
                    },
                    ".ui-block-11 a@onmousedown": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (offer.page === "results" || stored.redirectTo === "results" || !profile.VirtualsOctava) return;
                        if (this.Odd_TRIO_2) {
                            return 'ticket.ticketOddModule.ctAddOdd(' + this.Odd_TRIO_2.OddsID + ')';
                        } else {
                            return 'ticket.ticketOddModule.ctAddOdd()';
                        }
                    },
                    ".ui-block-11 a .ui-btn-text": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (!profile.VirtualsOctava) return;
                        var rate = "&nbsp;";
                        if (this.Odd_TRIO_2 && this.Odd_TRIO_2.OddsRate && (rate = this.Odd_TRIO_2.OddsRate.toFixed(2)) > 1) {
                            return '<div id="flg"></div><span id="crs">' + rate + '</span>';
                        } else {
                            return '<span id="crs" class="no-crs">' + rate + '</span>';
                        }
                    },
                    ".ui-block-11 a@tip-type": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (this.Odd_TRIO_2) return this.Odd_TRIO_2.TipType;
                    },
                    ".ui-block-11 a@tip-name": function (a) {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        if (offer.page !== "results" && this.Odd_TRIO_2) return a.context.Labels["TP_" + this.Odd_TRIO_2.TipID].Name;
                    },

                    // Button 12
                    ".ui-block-12 a@ID": function () {
                        if (!profile.VirtualsOctava && this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return;
                        else return this.EventID;
                    },
                    ".ui-block-12 a@channel": function () {
                        if (!profile.VirtualsOctava && this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return;
                        else return this.ChannelID;
                    },
                    ".ui-block-12 a@class+": function () {
                        if (!profile.VirtualsOctava && this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) return;
                        else {
                            var button = "";
                            if (offer.goldenLeague) {
                                button += ' ui-disabled';
                            } else if (offer.sportID == offer.vgID) {
                                button += virtual.virtualButton(this.LeagueCupID, this.ActualGamePartID, this.LiveBettingView, this.SideBet, this.Stream, this.ChannelID, this.Score);
                            } else if (this.SideBet && !["ended"].includes(this.ActualGamePartID)) {
                                button += ' btn-side-bet';
                            }
                            if (!marked && ticket.listCheck(null, this.EventID)) button += ' ui-btn-up-e';
                            return button;
                        }
                    },
                    ".ui-block-12 a .ui-btn-text": function () {
                        if (!profile.VirtualsOctava && this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF) {
                            return;
                        } else {
                            if (!(offer.sportID == offer.vgID && (!["notstarted", "nonstarted"].includes(this.ActualGamePartID)) || this.LiveBettingView == -1) && this.SideBet && !["ended"].includes(this.ActualGamePartID))
                                // TODO: prekontrolovat ci this.LiveBettingView == -1 je spravna podmienka
                                return '+' + this.SideBet;
                        }
                    },
                    ".ui-block-12 a@onmousedown": function () {
                        if (this.RegionID !== 1239 && offer.provider !== offer.providerNameUOF && !profile.VirtualsOctava) return;

                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    },
                },
                filter: function (a) {
                    // Vynecha vti zapasy okrem 1. ktory je vo videu
                    if (offer.vgL.uofTennis.includes(offer.leagueCupID)) {
                        if (offer.vti && offer.vti.actualFeedReference !== "") {
                            if (this.LiveFeedReference !== offer.vti.actualFeedReference) {
                                // Prechadzany zapas nieje vo videu 1.
                                return false;
                            } else if (this.EventID) {
                                // Aktualne prechadzany zapas je 1.
                                if (offer.eventID !== this.EventID) {
                                    // Otvori detail zapasu
                                    eventDetail.showEventDetail(this.EventID);
                                    // Oznaci event ako aktualne prehravany
                                    setTimeout(function() {
                                        $("#events #M" + this.EventID + " .virtual-game-play").addClass("virtual-game-playing");
                                    });
                                }
                            } else {
                                // Prvotne zobrazovanie zapasov
                                return true;
                            }
                        } else if (this.RegionID === 1239 && a.context.RenderedEvents && a.context.RenderedEvents.includes(this.EventID)) {
                            // Vynecha duplicitne zapasy (virtualny futbal)
                            return false;
                        }
                    } else if (offer.pointer === "FA0" && this.EventType !== "special") {
                        if (stored.PlayerFavorite.sport.includes(this.SportID) || stored.PlayerFavorite.leagueCup.includes(this.LeagueCupID)) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    if (this.RegionID === 1239 && offer.provider === offer.providerNameUOF && a.context.RenderedEvents && a.context.RenderedEvents.includes(this.EventID)) {
                        // Vynecha duplicitne zapasy (virtualny futbal)
                        return false;
                    }
                    // Vynecha masterChanceType typu VICTORIA, pripadne aj LIVE ak je zakazane
                    if (this.EventType === "special") {
                        offer.eventsVictoria = true;
                        return false;
                    } else if (!offer.live && this.LiveBetting == "Y") {
                        return false;
                    }
                }
            },
            ".@class+": function () {
                if (!stored.isFavoriteRender) {
                    // Prida clasu pre zobrazenie virtualneho futbalu s 8 tlacidlami, docasne prida classu offer-offer aby pocas zobrazovania plachty nerozhodilo ponuku. Spolu s clasou o aky typ rozsirenej ponuky sa jedna
                    return 'scroll-offer ' + ((profile.VirtualsOctava && offer.regionID === 1239 && offer.provider === offer.providerNameUOF) ? "virtuals-octava" : "") + ' events-' + stored.offerView.split(' ')[0] + '-view ' + (stored.offerView.split(' ')[1] ? (stored.offerView.split(' ')[1]) : "");
                }
            }
        }
    // Kompilacia direktivy pre '#events #section ul' je potrebna pre oblubene v plachte, ak by sa pouzila existujuca direktiva, DOM elementy s rovnakymi ID by sa vykrseslili vnorene pre oblubene
    T.eventsSexta = $p("#events #section, #events #section ul").compile(directive);
};

// Direktiva na renderovanie tabule zapasov - dlhodobe stavky
directives.eventsDirective.eventsVictoria = function() {
    var directive = {
        ".@class+": function () {
            var victoryClass = " events-victoria";
            if (offer.sportID === offer.vgID && profile.InlineDetailLeagueCups.includes(offer.leagueCupID)) {
                victoryClass += " events-inline-detail"; // detail rozbaleny ako acordeon v plachte - napr. virtualne stavky na kone (prebiehajuce)
           }
           return victoryClass;
       },
        ".events-sport-header": function (a) {
            if (offer.pointer === "FA0" && (!lastSportID)) {
               // Prvotne zobrazenie v oblubenych
               lastSportID = this.SportID;
           }
       },
        "li": {
            // Generuje jedntolive eventy
            "Event<-EventChanceTypes": {
                ".@id": function () {
                    // Parsovanie event detailu (LIVE / next LIVE / Prematch)
                    this.Event = $.extend(this.Event, eventDetail.parseEvent(this.LiveFeedReference, this.LiveBetting, this.SportID, this.ActualGamePartID, this.ActualGamePartTime, this.EventDate, this.EventID));
                    if (!this.Event.Date) this.Event.Date = "&nbsp;";
                    if (!(this.Event.Time += this.Event.Label)) this.Event.Time = "&nbsp;";
                    // Nastavi ID zapasu - s priznakom "M"
                    return ("M" + this.EventID);
                },
                ".@class+": function () {
                    var eventClass = "";
                    if (this.SportID == offer.vgID) {
                        eventClass = " virtual-event";
                    } else if (this.LiveBetting == "Y") {
                        eventClass = " live-event";
                    } else if (this.Event.NextLive) {
                        eventClass = " next-live-event";
                    } else {
                        eventClass = " prematch-event";
                    }
                    return eventClass;
                },
                ".@liveFeed-reference": function () {
                    if (this.LiveFeedReference > 0) return this.LiveFeedReference;
                },
                ".@event-date": function () {
                    if (this.Event.EventDate) return this.Event.EventDate;
                },
                ".@event-parent": function () {
                    return this.EventID;
                },
                ".@betType": "Event.BetType",
                ".@event-chanceType-ID": "Event.EventChanceTypeID",
                ".@chanceType-ID": "Event.ChanceTypeID",
                ".@chanceType-name": "Event.ChanceTypeName",
                ".events-n-sport-header": function (a) {
                    if (offer.pointer === "FA0") {
                        if (lastSportID !== this.SportID) {
                            // Prvotne zobrazenie v oblubenych
                            lastSportID = this.SportID;
                            return events.sportHeader(this.SportID, a.context.Labels["SP_" + this.SportID].Name, player.playerFavoritesModule.favoriteButtonState(stored.favTypes.sport, this.SportID));
                        } else if (!lastSportID) {
                             lastSportID = this.SportID;
                        }
                    }
               },
               ".events-n-sport-header@class+": function () {
                    if (lastSportID === this.SportID) {
                        return "-disabled";
                    }
                },
                ".league-title@sport-id": function (a) {
                    if (this.SportID != -1) {
                        this.SportName = a.context.Labels["SP_" + this.SportID].Name;
                        return 'SP' + this.SportID;
                    } else {
                        this.SportName = a.context.Labels["SE_" + this.SportEventID].Name;
                        return 'SE' + this.SportEventID;
                    }
                },
                ".league-title@region-id": "RE#{Event.RegionID}",
                ".league-title@id": "LC#{Event.LeagueCupID}",
                ".league-title": function (a) {
                    var header = "";
                    if (buttonState = player.playerFavoritesModule.favoriteButtonState(stored.favTypes.leagueCup, this.SportID, this.LeagueCupID)) {
                        header += '<div class="favorite-event '
                        + buttonState + '" onmousedown="player.playerFavoritesModule.editPlayerFavorite('
                        + this.SportID + ", "
                        + this.LeagueCupID + ')"><div class="icon-favorite"></div></div>';
                    }
                    if (a.leagueCupID != this.LeagueCupID) {
                        a.leagueCupID = this.LeagueCupID;
                        if (regionName = a.context.Labels["RE_" + this.RegionID].Name) {
                            if (leagueCupName = a.context.Labels["LC_" + this.LeagueCupID].Name) {
                                return header + '<div class="label-main sport-bgColor-' + this.SportID + '" sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '">'
                                    + regionName + ' - ' + (offer.vgID === offer.sportID && this.Provider? '<span class="provider-icon flag_' + this.Provider + ' size33"></span>' + texts["ProviderName" + this.Provider] + ' - ': '' )  + leagueCupName + '</span></div>';
                            } else {
                                return header + '<div sport-name="' + this.SportName + '" region-name="' + regionName + '">' + regionName + '</div>';
                            }
                        }
                    } else {
                        return '<span sport-name="' + this.SportName + '" region-name="' + regionName + '" leagueCup-name="' + leagueCupName + '"></span>';
                    }
                },
                "fieldset@class": function () {
                    var chanceType = "";
                    if (this.EventChanceTypeStatus) chanceType = "chanceType-" + this.EventChanceTypeStatus;
                    if (this.LiveBettingView == -1 || (this.SportID == offer.vgID && !["notstarted", "nonstarted"].includes(this.ActualGamePartID))) chanceType += " event-suspended";
                    if (chanceType) return chanceType;
                },
                // Button 1
                ".ui-block-1 .ui-icon-sports@class+": " sport-#{Event.SportID} region-#{Event.RegionID}",
                ".ui-block-1 a+": function () {
                    if (profile.ShowStatistics && profile.StatisticsParameter === "hasBetradarHostedStatistics") {
                        // Statistiky na zobrazenie na spodnej sb obrazovke
                        if (this.Widgets?.includes("statistics") && this.BetradarStatisticsUrn && this.BetradarStatisticsUrl) return '<span class="ui-icon-main h2h-ico"></span>';
                    }
                },
                ".ui-block-1 a@class+": function () {
                    if (this.LiveBetting == "Y") {
                        // Zobrazi LIVE a podla gamePartID nastavi farbu
                        return ' is-live game-' + this.ActualGamePartID;
                    } else if (this.Event.NextLive) {
                        // Zobrazuje ako nextLive len udalosti, ktore budu v LIVE v ramci akutalnej hodiny
                        return ' next-live';
                    }
                },
                ".ui-block-1 a@onclick": function () {
                    if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(this.LeagueCupID)) {
                        return 'eventDetail.eventDetailInlineModule.showEventDetailInline(' + this.EventID + ')';
                    } else {
                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    }
                },
                ".ui-block-1 a .ui-btn-text": function () {
                    return '<span>' + this.Event.Date + '</span><p class="ui-li-desc">' + this.Event.Time + '</p>';
                },

                // Button 2 (2to4)
                ".ui-block-2 a .ui-btn-text": function (a) {
                    var iconsWrapper = "";
                    if ((this.RegionName = a.context.Labels["RE_" + this.RegionID].Name) && offer.page != "virtualGames") {
                        this.LongName = this.RegionName;
                        if (this.LeagueCupName = a.context.Labels["LC_" + this.LeagueCupID].Name)
                            this.LongName += " - " + this.LeagueCupName;
                    }
                    if (this.EventName) this.LongName = this.EventName;

                    if (this.ChanceTypeName && this.BetType == "VICTORIA_COMPETITOR") {
                        var chanceTypeName = "<div class='events-victoria-right'>" + this.ChanceTypeName + "</div>";
                    }
                    if (this.Widgets?.includes("matchtracker")) {
                        // Overallove stavky mozu mat matchtracker (F1 overall)
                        iconsWrapper = "<span class='icons-wrapper'><span class='icon-field'></span></span>";
                    }
                    if (chanceTypeName) {
                        return '<div region-name="' + this.RegionName + '" class="events-victoria-left">' + this.LongName + '</div>' + chanceTypeName + iconsWrapper;
                    } else {
                        return '<div region-name="' + this.RegionName + '" class="events-victoria-left full-width">' + this.LongName + '</div>' + iconsWrapper;
                    }
                },
                ".ui-block-2 a@onclick": function () {
                    if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(this.LeagueCupID)) {
                        return 'eventDetail.eventDetailInlineModule.showEventDetailInline(' + this.EventID + ')';
                    } else {
                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    }
                },
                ".ui-block-3": "",
                ".ui-block-4 a .ui-btn-text": function () {
                    if ((offer.sportID == offer.vgID) && profile.InlineDetailLeagueCups.indexOf(this.LeagueCupID) !== -1) {
                        return '+' + this.SideBet;
                    }
                },
                ".ui-block-4 a@onclick": function () {
                    if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(this.LeagueCupID)) {
                        return 'eventDetail.eventDetailInlineModule.showEventDetailInline(' + this.EventID + ')';
                    }
                },
                ".ui-block-4 a@class+": function () {
                    if (["ended"].includes(this.ActualGamePartID)) return ' ui-disabled';
                    if (!["notstarted", "nonstarted", "ended"].includes(this.ActualGamePartID)) {
                        return ' ui-disabled';
                    }
                },
                // Button 5
                ".ui-block-5 a@ID": "Event.EventID",
                ".ui-block-5 a@channel": "Event.ChannelID",
                ".ui-block-5 a@class+": function () {
                    var button = "";
                    if (offer.sportID == offer.vgID) {
                        if (["ended"].includes(this.ActualGamePartID) || this.Score) {
                            button += ' ui-disabled';
                        } else if ((!offer.vgL.uofRacing.includes(offer.leagueCupID) && !["notstarted", "nonstarted", "ended"].includes(this.ActualGamePartID)) ||
                            (offer.vgL.uofRacing.includes(offer.leagueCupID) && this.LiveBettingView === -1)) {
                            button += ' virtual-game-play';
                            if ((!this.ChannelID || this.ChannelID == stored.topScreenVgChannel)
                                && (!stored.topScreenVgVirtualLeague || (stored.topScreenVgVirtualLeague == this.LeagueCupID))) {
                                if (!stored.topScreenVgVirtualLeague) {
                                    stored.topScreenVgVirtualLeague = this.LeagueCupID;
                                }
                                button += ' virtual-game-playing';
                            }
                        }
                    }
                    if (ticket.listCheck(null, this.EventID)) {
                        button += ' ui-btn-up-e';
                    }
                    return button;
                },
                ".ui-block-5 a@onclick": function () {
                    if (profile.FlatCSS && profile.InlineDetailLeagueCups.includes(this.LeagueCupID)) {
                        return 'eventDetail.eventDetailInlineModule.showEventDetailInline(' + this.EventID + ')';
                    } else {
                        return 'eventDetail.showEventDetail(' + this.EventID + ', false, false, ' + (offer.page === 'results') + ')';
                    }
                },
                ".ui-block-6": "",
                ".ui-block-7": "",
                ".ui-block-8": "",
                ".ui-block-9": "",
                ".ui-block-10": "",
                ".ui-block-11": "",
                ".ui-block-12": "",
                ".ui-block-12": "",
            },
            filter: function (a) {
                // Vyrenderuje len masterChanceType typu VICTORIA, pripadne vynecha LIVE ak je zakazane
                if (this.EventType == "default" || (!offer.live && this.LiveBetting == "Y")) {
                    return false;
                } else if (offer.pointer === "FA0" && stored.UserSettings.Original.favoriteSportLeague === "1") {
                    if (stored.PlayerFavorite.sport.includes(this.SportID) || stored.PlayerFavorite.leagueCup.includes(this.LeagueCupID)) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (offer.sportID == offer.vgID && this.Provider === offer.providerNameBTX && !a.context.topScreenDataSent && offer.vgL.evona.includes(a.item.LeagueCupID)) {
                    a.context.topScreenDataSent = true;
                    communication.topScreen("virtualsEvona", { Events: a.Event.items });
                }
            }
        }
    }
    T.eventsVictoria = $p("#events #section ul").compile(directive);
};
